import {IElement} from '../../../incase-domain/elements';

export const SET_CLIPBOARD_DATA = 'SET_CLIPBOARD_DATA';
export const CLEAR_CLIPBOARD_DATA = 'CLEAR_CLIPBOARD_DATA';

export interface ISetClipboardDataAction {
    type: typeof SET_CLIPBOARD_DATA;
    payload: {
        data: IElement;
    };
}

export interface IClearClipboardDataAction {
    type: typeof CLEAR_CLIPBOARD_DATA;
}

export type ClipboardActionTypes = ISetClipboardDataAction | IClearClipboardDataAction;
